import api from '@/utils/api';

/**
 * Get Quoting Customers
 * @returns {Promise}
 */
const getQuotingCustomersApi = () => api.get(`/conf/contacts`);

export default getQuotingCustomersApi;
